import { Badge } from '@/components/ui/badge';
import type { RecordStatus } from '../types';

const statusConfig: Record<RecordStatus, { label: string; variant: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline' }> = {
  pending: { label: 'En attente', variant: 'secondary' },
  mapped: { label: 'Mappé', variant: 'default' },
  validated: { label: 'Validé', variant: 'default' },
  migrated: { label: 'Migré', variant: 'success' },
  failed: { label: 'Échoué', variant: 'destructive' },
  skipped: { label: 'Ignoré', variant: 'outline' },
  // Orange : un exclu n'est ni une réussite ni un échec — c'est une ligne
  // écartée volontairement (donnée V1 inexploitable, ou décision d'un
  // opérateur). Elle doit rester repérable dans le rapport, sans alarmer
  // comme un échec puisqu'il n'y a rien à corriger.
  excluded: { label: 'Exclu', variant: 'warning' },
  review_needed: { label: 'À vérifier', variant: 'warning' },
};

interface RecordStatusBadgeProps {
  status: RecordStatus;
  className?: string;
}

export function RecordStatusBadge({ status, className }: RecordStatusBadgeProps) {
  const config = statusConfig[status] ?? { label: status, variant: 'secondary' as const };

  return (
    <Badge variant={config.variant} className={className}>
      {config.label}
    </Badge>
  );
}
